import shapePack from "./packs/shape/ordered-icon-map"
import lineStrokePack from "./packs/line_stroke/icon-map"
import lineWidthPack from "./packs/line_width/icon-map"
import {
    FireAIIconPack,
    NWCGIconPack,
    BCWSIconPack,
    ForestryIconPack,
    SarcopIconPack,
    NWCGLinePack,
    NWCGPolygonPack,
    NFPAEmergencyPack,
    NFPAFireServicePack,
    NFPAGeneralUsePack,
} from "./icon-packs"
import {
    FireAIIconPaths,
    NWCGIconPaths,
    BCWSIconPaths,
    ForestryIconPaths,
    SarcopIconPaths,
    NWCGLinePaths,
    NWCGPolygonPaths,
    NFPAEmergencyIconPaths,
    NFPAFireServicePaths,
    NFPAGeneralUsePaths,
    NumberPaths,
} from "./icon-paths"
import { IconPackMap } from "./packs/types"

const defaultIconSize = 32
enum RegisteredIconPacks {
    fireai = "fireai",
    nwcg = "nwcg",
    shape = "shape",
    numbers = "numbers",
    bcws = "bcws",
    forestry = "forestry",
    sarcop = "sarcop",
    nfpaEmergency = "nfpa_emergency",
    nfpaFireService = "nfpa_fire_service",
    nfpaGeneralUse = "nfpa_general_use",
}
const iconPackSizes: Record<RegisteredIconPacks, number> = {
    fireai: 32,
    nwcg: 24,
    shape: 16,
    numbers: 32,
    bcws: 24,
    forestry: 24,
    sarcop: 24,
    nfpa_emergency: 32,
    nfpa_fire_service: 32,
    nfpa_general_use: 32,
}

const getPackPrefix = (pack?: string) => {
    if (!pack) return
    for (const value of Object.values(RegisteredIconPacks)) {
        if (pack.startsWith(value)) return value
    }
}

const getPackSize = (pack?: string) => {
    if (!pack) return defaultIconSize
    const prefix = getPackPrefix(pack)
    if (!prefix) {
        return defaultIconSize
    }
    return iconPackSizes[prefix]
}

const getIconPack = (url: string) => {
    if (!url) return
    return url.split("/")?.[0]
}

const iconPaths: Record<string, IconPackMap | undefined> = {
    ...FireAIIconPaths,
    ...NumberPaths,
    shape: shapePack,
    ...NWCGIconPaths,
    ...BCWSIconPaths,
    ...ForestryIconPaths,
    ...SarcopIconPaths,
    ...NWCGLinePaths,
    ...NWCGPolygonPaths,
    ...NFPAEmergencyIconPaths,
    ...NFPAFireServicePaths,
    ...NFPAGeneralUsePaths,
    line_stroke: lineStrokePack,
    line_width: lineWidthPack,
}

const iconFileName = (iconKey: string) =>
    iconKey
        .split("_")
        .map((e) => e.charAt(0).toUpperCase() + e.slice(1))
        .join("_")

const iconAssetPath = (url: string) => {
    const [pack, iconKey] = url.split("/")

    if (!iconPaths[pack] || !iconKey) return null
    return `${pack}/svg/${iconFileName(iconKey)}.svg`
}

const getIconUrl = (url: string) => {
    const assetPath = iconAssetPath(url)
    if (!assetPath) return null
    return `/icons/${assetPath}`
}

const iconDisplayName = (url: string) => {
    const [pack, iconKey] = url.split("/")
    if (!iconKey) return url
    return iconPaths[pack]?.[iconKey]?.name ?? iconKey
}

export {
    FireAIIconPack as FireAIPack,
    FireAIIconPaths,
    shapePack as ShapePack,
    lineStrokePack as LineStrokePack,
    lineWidthPack as LineWidthPack,
    NWCGIconPack as NWCGPack,
    NWCGLinePack,
    NWCGIconPaths,
    NWCGLinePaths,
    NWCGPolygonPack,
    NWCGPolygonPaths,
    getPackSize,
    getPackPrefix,
    getIconPack,
    getIconUrl,
    iconAssetPath,
    iconDisplayName,
    iconFileName,
    iconPaths,
    BCWSIconPack as BCWSPack,
    SarcopIconPack as SarcopPack,
    BCWSIconPaths,
    ForestryIconPack as ForestryPack,
    ForestryIconPaths,
    SarcopIconPaths,
    NFPAEmergencyPack,
    NFPAGeneralUsePack,
    NFPAFireServicePack,
    NFPAEmergencyIconPaths,
    NFPAGeneralUsePaths,
    NFPAFireServicePaths,
    RegisteredIconPacks,
}
